/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Label from '../../../../fields/normal/GeneralCheckbox/Label';

const MarketingCheckboxLabel = () => (
  <Label>
    {`I agree James Hardie may add my information to its database and send me emails about its products and services from time to time.`}
  </Label>
);

export default MarketingCheckboxLabel;
